import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import OurRooms from "../pages/OurRooms";
import RoomDetails from "../pages/RoomDetails";
import Contact from "../pages/Contact";
import TermsConditions from "../pages/TermsConditions";
import Gallery from "../pages/Gallery";
import GalleryView from "../pages/GalleryView";
import Booking from "../pages/Booking";
import Faqs from "../pages/Faqs";

// const RedirectToDashboard = () => {
//   useEffect(() => {
//     window.location.href = `${process.env.REACT_APP_strapiUrl}/admin/content-manager`;
//   }, []);

//   return null;
// };

const RedirectToDashboard = () => {
  useEffect(() => {
    window.location.href = `https://sos.scieverinc.com`;
  }, []);

  return null;
};

const Main = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/our-rooms" element={<OurRooms />} />
        <Route path="/our-rooms/rooms-details" element={<RoomDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-condition" element={<TermsConditions />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/gallery-view" element={<GalleryView />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/dashboard" element={<RedirectToDashboard />} />
      </Routes>
    </>
  );
};

export default Main;
